import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { MenuConfig } from 'src/app/configs/menu-config';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  public menuConfig: any;
  public filterMenuList: any = [];
  public permissions: any = [];

  constructor(
    public authService: AuthService,
    public router: Router,
    public translate: TranslateService,
    private permissionsService: NgxPermissionsService
  ) { }

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/auth']);
      return false;
    }
    this.setPermissionConfigs();
    return true;
  }

  setPermissionConfigs() {
    let json = JSON.stringify(new MenuConfig().configs);
    this.menuConfig = JSON.parse(json);
    this.menuConfig.aside = [];
    let tmpAsides = [...JSON.parse(json).aside];
    const action = 'view';
    // console.log('aside --- ', JSON.parse(json).aside)
    // console.log('tmpAsides --- ', tmpAsides)
    JSON.parse(json).aside.forEach((item, i) => {
      const item_index = tmpAsides.findIndex((e) => e.translate === item.translate);
      if (item.title) {
        //check is not Section
        // show menu
        if (item.submenu) {
          item.submenu.forEach((sub_item, j) => {
            const submenu_index = tmpAsides[item_index].submenu.findIndex((e) => e.translate === sub_item.translate);
            if (sub_item.submenu) {
              sub_item.submenu.forEach((sub_sub_item) => {
                const sub_submenu_index = tmpAsides[item_index].submenu[submenu_index].submenu.findIndex(
                  (e) => e.translate === sub_sub_item.translate,
                );
                if (!this.authService.hasPermission(this.translateName(`${sub_sub_item.translate}`), action)) {
                  tmpAsides[item_index].submenu[submenu_index].submenu.splice(sub_submenu_index, 1);
                } else {
                  this.filterMenuList.push(sub_sub_item);
                }
              });
            } else {
              if (!this.authService.hasPermission(this.translateName(`${sub_item.translate}`), action)) {
                tmpAsides[item_index].submenu.splice(submenu_index, 1);
              } else {
                this.filterMenuList.push(sub_item);
              }
            }
          });
        } else {
          if (!this.authService.hasPermission(this.translateName(`${item.translate}`), action)) {
            tmpAsides.splice(item_index, 1);
          } else {
            this.filterMenuList.push(item);
          }
        }
      } else {
        // show section
        if (!this.authService.hasPermission(null, null, this.translateName(`${item.translate}`))) {
          tmpAsides.splice(item_index, 1);
        }
      }
    });
    const filterTemAsides = tmpAsides.filter(
      (i) =>
        i.section ||
        (i.submenu && i.submenu.filter((ss) => !ss.submenu || (ss.submenu && ss.submenu.length > 0)).length > 0) ||
        !i.submenu,
    );
    this.menuConfig.aside = filterTemAsides;
    // console.log('filterTemAsides --- ', filterTemAsides)
    this.setPermissionkey();
  }

  setPermissionkey() {
    this.permissions = [];
    const permission_list = JSON.parse(sessionStorage.getItem('permissions'));

    if (permission_list) {
      permission_list.forEach((perm) => {
        const menu = this.filterMenuList.find((m) => this.translateName(m.translate) === perm.permission);
        if (menu) {
          this.permissions.push(`${this.getAction(perm.action)}${menu.page}`);
        }
      });

      this.permissionsService.loadPermissions(this.permissions);
    } else {
      this.authService.logout();
    }
  }

  translateName(translate_name) {
    return this.translate.instant(translate_name);
  }


  getPath(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const find = this.filterMenuList.find((item) => this.translateName(item.translate) === params.permission_module_name);
        // console.log('find ==> ', find);
        resolve(find || null);
      }, 300);
    });
  }



  getAction(action) {
    switch (action) {
      case 'ดู':
        return 'view';
      case 'เพิ่ม':
        return 'create';
      case 'แก้ไข':
        return 'update';
      case 'ลบ':
        return 'delete';
      case 'Reverse/ยกเลิก/ปิดรุ่น':
        return 'reverse';
      case 'เข้าถึงpos':
        return 'POS';
      default:
        return action;
    }
  }
}
